import React, { FC } from 'react';
import styled from 'styled-components';
import dayjs from 'dayjs';

import Column from 'components/common/Column';
import Text from 'components/common/Text';
import CommonImage from 'components/common/CommonImage';
import { ICON_CHECK_BLUE } from 'assets/icons';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  position: relative;
  min-width: 87px;
`;

const StepCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 24px;
  height: 24px;

  border-radius: 50%;
  background-color: #dbdcdf;
  color: #fff;
  font-size: 16px;
`;

const Line = styled.div`
  position: absolute;
  top: 11px;
  left: 110%;

  width: 64px;
  height: 1px;

  background-color: #dbdcdf;
  transform: translateX(-50%);
`;

interface Props {
  idx: number;
  title: string;
  date: number;
  isActive: boolean;
}

const DeliveryStep: FC<Props> = props => {
  const { idx, title, date, isActive } = props;

  return (
    <Container>
      {isActive ? (
        <CommonImage src={ICON_CHECK_BLUE} />
      ) : (
        <StepCircle>{idx}</StepCircle>
      )}
      <Column gap="4px">
        <Text color="#46474c" size="12px" style={{ lineHeight: '16px' }}>
          {title}
        </Text>
        {(isActive || date) && (
          <Text color="#989BA2" size="12px" weight={400}>
            {dayjs(date).format('YYYY년 MM월 DD일')}
          </Text>
        )}
      </Column>
      {idx !== 5 && <Line />}
    </Container>
  );
};

export default DeliveryStep;
